import {useEffect, useRef} from 'react';
import {TResourceSubmitStatus} from 'admin/resources/upload/store/IUploadStoreState';

export const useResourceSubmitOutcome = (
  status: TResourceSubmitStatus,
  onSuccess: () => void,
  onError: () => void,
  clear: () => void
) => {
  const onSuccessRef = useRef(onSuccess);
  const onErrorRef = useRef(onError);
  const clearRef = useRef(clear);
  onSuccessRef.current = onSuccess;
  onErrorRef.current = onError;
  clearRef.current = clear;

  useEffect(() => {
    if (status === 'success') {
      onSuccessRef.current();
      clearRef.current();
      return;
    }

    if (status === 'error') {
      onErrorRef.current();
      clearRef.current();
    }
  }, [status]);
};
